import { render, staticRenderFns } from "./FormTest.vue?vue&type=template&id=24fc2282"
import script from "./FormTest.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormTest.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FormTest.vue?vue&type=style&index=0&id=24fc2282&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports